<template>
    <form-accordion
        name="password"
        section="Password"
        :url="url"
        method="patch"
        :closed="closed"
        @saved="saved"
    >
        <p class="text-gray-700 sm:text-md text-center leading-snug pt-5">
            {{ $t('To change your account password, enter a new password below.') }}
            <br>
            <span class="text-sm">
                {{ $t('(Minimum 8 characters)') }}
            </span>
        </p>

        <div class="flex flex-col sm:flex-row -mt-2">
            <div class="sm:col-gap-2 flex-1">
                <input-text
                    :label="$t('Password')"
                    name="password"
                    type="password"
                    v-model="password"
                />
            </div>

            <div class="mt-4 sm:mt-0 sm:col-gap-2 flex-1">
                <input-text
                    :label="$t('Confirm Password')"
                    name="password_confirmation"
                    type="password"
                    v-model="password_confirmation"
                />
            </div>
        </div>

        <p v-if="saved_successfully" class="text-green-600 text-md pt-5">
            {{ $t('Your password has been successfully updated.') }}
        </p>
    </form-accordion>
</template>

<script>
export default {
    props: {
        closed: { default: true },
        url: {},
        broker: {},
    },

    data() {
        return {
            password: null,
            password_confirmation: null,
            saved_successfully: false,
        }
    },

    methods: {
        saved() {
            this.password = null;
            this.password_confirmation = null;
            this.saved_successfully = true;
        },
    },

    watch: {
        password(val, oldVal) {
            if (! oldVal) {
                this.saved_successfully = false;
            }
        },
        password_confirmation(val, oldVal) {
            if (! oldVal) {
                this.saved_successfully = false;
            }
        },
    },
}
</script>
